<p>
  bar-chart-example works!
</p>
